/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Csjensblank_Hda14Inputs */

const en__field_enum_csjensblank_hda14 = /** @type {(inputs: _Field_Enum_Csjensblank_Hda14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hochschule Darmstadt`)
};

const de__field_enum_csjensblank_hda14 = /** @type {(inputs: _Field_Enum_Csjensblank_Hda14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hochschule Darmstadt`)
};

/**
* | output |
* | --- |
* | "Hochschule Darmstadt" |
*
* @param {_Field_Enum_Csjensblank_Hda14Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_csjensblank_hda14 = /** @type {((inputs?: _Field_Enum_Csjensblank_Hda14Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Csjensblank_Hda14Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_csjensblank_hda14(inputs)
	return de__field_enum_csjensblank_hda14(inputs)
});
export { _field_enum_csjensblank_hda14 as "_field_enum_CSJENSBLANK_HDA" }